import { api } from '@/lib/api';
import type {
  IApiResponse,
  IPublicPersonListQuery,
  IPublicPersonListResponse,
} from '@skystone/shared';

function buildListUrl(params?: IPublicPersonListQuery): string {
  const search = new URLSearchParams();
  if (params?.search) search.set('search', params.search);
  if (params?.page) search.set('page', String(params.page));
  if (params?.pageSize) search.set('pageSize', String(params.pageSize));
  const query = search.toString();
  return query ? `/people?${query}` : '/people';
}

export const peopleApi = {
  list: async (params?: IPublicPersonListQuery): Promise<IPublicPersonListResponse> => {
    const result = await api.get<IApiResponse<IPublicPersonListResponse>>(buildListUrl(params));
    return result.data;
  },
};
